import { BaseFetch } from "../main-model";
export default class SchoolModel extends BaseFetch {
  getSchoolBy = (data) =>
    this.authFetch({
      url: "school/getSchoolBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getOnlySchoolBy = (data) =>
    this.authFetch({
      url: "school/getOnlySchoolBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getSchoolById = (data) =>
    this.authFetch({
      url: "school/getSchoolById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getSchoolWuthGroupById = (data) =>
    this.authFetch({
      url: "school/getSchoolWuthGroupById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateSchoolById = (data) =>
    this.authFetch({
      url: "school/updateSchoolById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertSchool = (data) =>
    this.authFetch({
      url: "school/insertSchool",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteSchoolById = (data) =>
    this.authFetch({
      url: "school/deleteSchoolById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getAddeersById = (data) =>
    this.authFetch({
      url: "school/getAddeersById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertSchoolAddress = (data) =>
    this.authFetch({
      url: "school/insertSchoolAddress",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateSchoolAddressById = (data) =>
    this.authFetch({
      url: "school/updateSchoolAddressById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getSchoolCheckBy = (data) =>
    this.authFetch({
      url: "school/getSchoolCheckBy",
      method: "POST",
      body: JSON.stringify(data),
    });
}
